exports.TiersType = {
    CLIENT: "Client",
    FOURNISSEUR: "Fournisseur",
  };
  
  exports.SALE_STATUS = {
    PENDING: "PENDING",
    IN_PROGRESS: "IN PROGRESS",
    COMPLETE: "COMPLETE",
    CANCELLED: "CANCELED",
  };

  exports.DocumentIdName = {
    LIVRAISON: "678e36b682b64922204a78d2",
    ORDRE_DE_LIVRAISON: "678e367382b64922204a78d0",
    COMMANDE_CLIENT:'67a15a4cafdb89c59074f89c',
    ENTREE_STOCK:'676356aa76fb12de5a988f75',
    SORTIE_STOCK:'676356aa76fb12de5a988f76',
    
  };
  
  exports.ACTION_PERMISSIONS = {
    ADD_ARTICLE: "create.canCreateArticle",
    ADD_SHOP: "create.canCreateShop",
    ADD_COMMANDE: "create.canCreateCommande",
    ADD_ORDRE_DE_LIVRAISON: "create.canCreateOrdreDeLivraison",
    ADD_BON_DE_LIVRAISON: "create.canCreateBonDeLivraison",
    ADD_ENTREE: "create.canCreateEntree",
    ADD_SORTIE: "create.canCreateSortie",
    ADD_FACTURE_CLIENT: "create.canCreateFactureClient",
    ADD_FACTURE_FOURNISSEUR: "create.canCreateFactureFournisseur",
    ADD_PROFORMA: "create.canCreateProforma",
    ADD_AVOIR_CLIENT: "create.canCreateAvoirClient",
    ADD_AVOIR_FOURNISSEUR: "create.canCreateAvoirFournisseur",
    ADD_FOURNISSEUR: "create.canCreateFournisseur",
    ADD_BON_DE_TRANSFERT: "create.canCreateBonDeTransfert",
    ADD_CLIENT: "create.canCreateClient",
  
    EDIT_ARTICLE: "update.canUpdateArticle",
    EDIT_SHOP: "update.canUpdateShop",
    EDIT_COMMANDE: "update.canUpdateCommande",
    EDIT_ORDRE_DE_LIVRAISON: "update.canUpdateOrdreDeLivraison",
    EDIT_BON_DE_LIVRAISON: "update.canUpdateBonDeLivraison",
    EDIT_ENTREE: "update.canUpdateEntree",
    EDIT_SORTIE: "update.canUpdateSortie",
    EDIT_FACTURE_CLIENT: "update.canUpdateFactureClient",
    EDIT_FACTURE_FOURNISSEUR: "update.canUpdateFactureFournisseur",
    EDIT_PROFORMA: "update.canUpdateProforma",
    EDIT_AVOIR_CLIENT: "update.canUpdateAvoirClient",
    EDIT_AVOIR_FOURNISSEUR: "update.canUpdateAvoirFournisseur",
    EDIT_FOURNISSEUR: "update.canUpdateFournisseur",
    EDIT_BON_DE_TRANSFERT: "update.canUpdateBonDeTransfert",
    EDIT_CLIENT: "update.canUpdateClient",
  
    DELETE_ARTICLE: "delete.canDeleteArticle",
    DELETE_SHOP: "delete.canDeleteShop",
    DELETE_COMMANDE: "delete.canDeleteCommande",
    DELETE_ORDRE_DE_LIVRAISON: "delete.canDeleteOrdreDeLivraison",
    DELETE_BON_DE_LIVRAISON: "delete.canDeleteBonDeLivraison",
    DELETE_ENTREE: "delete.canDeleteEntree",
    DELETE_SORTIE: "delete.canDeleteSortie",
    DELETE_FACTURE_CLIENT: "delete.canDeleteFactureClient",
    DELETE_FACTURE_FOURNISSEUR: "delete.canDeleteFactureFournisseur",
    DELETE_PROFORMA: "delete.canDeleteProforma",
    DELETE_AVOIR_CLIENT: "delete.canDeleteAvoirClient",
    DELETE_AVOIR_FOURNISSEUR: "delete.canDeleteAvoirFournisseur",
    DELETE_FOURNISSEUR: "delete.canDeleteFournisseur",
    DELETE_BON_DE_TRANSFERT: "delete.canDeleteBonDeTransfert",
    DELETE_CLIENT: "delete.canDeleteClient",
  
    VIEW_ARTICLE: "display.canDisplayArticle",
    VIEW_SHOP: "display.canDisplayShop",
    VIEW_COMMANDE: "display.canDisplayCommande",
    VIEW_ORDRE_DE_LIVRAISON: "display.canDisplayOrdreDeLivraison",
    VIEW_BON_DE_LIVRAISON: "display.canDisplayBonDeLivraison",
    VIEW_ENTREE: "display.canDisplayEntree",
    VIEW_SORTIE: "display.canDisplaySortie",
    VIEW_FACTURE_CLIENT: "display.canDisplayFactureClient",
    VIEW_FACTURE_FOURNISSEUR: "display.canDisplayFactureFournisseur",
    VIEW_PROFORMA: "display.canDisplayProforma",
    VIEW_AVOIR_CLIENT: "display.canDisplayAvoirClient",
    VIEW_AVOIR_FOURNISSEUR: "display.canDisplayAvoirFournisseur",
    VIEW_FOURNISSEUR: "display.canDisplayFournisseur",
    VIEW_BON_DE_TRANSFERT: "display.canDisplayBonDeTransfert",
    VIEW_CLIENT: "display.canDisplayClient",
  };
  